<template>
  <div @keyup.enter="confirm">
    <div class="filter-title">{{ title }}</div>

    <div v-for="(item, i) in computedList" :key="i">
      <UiCheckbox :id="`${queryKey}-checkbox-${i}`" v-model="item.checked" :label="item.label" />
    </div>

    <div class="filter-operation">
      <UiButton :class="['button', 'is-small', 'is-blue']" @click="confirm"> Применить </UiButton>
      <UiButton :class="['button', 'is-small', 'is-light']" @click="reset"> Очистить </UiButton>
    </div>
  </div>
</template>

<script>
import common from './common'

export default {
  components: {
    UiCheckbox: () => import('@/components/UiCheckbox.vue'),
    UiButton: () => import('@/components/UiButton.vue'),
  },
  mixins: [common],
  data() {
    return {
      computedList: [],
    }
  },
  watch: {
    list: {
      handler: 'setQuerySelected',
    },
  },
  methods: {
    reset() {
      this.updateQueryParams({
        query: { ...this.$query, page: null, [this.queryKey]: null },
      })

      this.closeFn()
    },

    confirm() {
      let labels = this.computedList.filter((x) => x.checked).map((x) => x.value)

      if (labels && labels.length <= 0) labels = null

      this.updateQueryParams({
        query: { ...this.$query, page: null, [this.queryKey]: labels },
      })

      this.closeFn()
    },

    setQuerySelected() {
      this.computedList = this.list

      const query = this.$query[this.queryKey]

      if (!query) return

      this.computedList = this.list.map((item) => {
        const value = item.value.toString()

        return {
          ...item,
          checked: query.includes(value),
        }
      })
    },
  },
}
</script>
